import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaCheckCircle,
  FaUsers,
  FaShoppingCart,
  FaLock,
  FaPlus,
  FaClipboardList,
  FaInfoCircle,
} from "react-icons/fa";
import { useUser } from "../../AdminUsers/UserContext";
import axios from "axios";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { localserver } from "../../../api/common";
import { FormCheck, Alert } from "react-bootstrap";
import { UpdateCustomeRegCode } from "../../../api/Webservices";
const Settings = () => {
  const {
    settingsDetails,
    buyerForm,
    fetchSettingsDetails,
    checkPermission,
    getValidation,
    regDetails,
  } = useUser();

  const [helpSupportEnabled, setHelpSupportEnabled] = useState(false);
  const [helpEmail, setHelpEmail] = useState("");
  const [activeTab, setActiveTab] = useState("general");
  const [allowLogin, setAllowLogin] = useState(false);
  const [allowMultipleTickets, setAllowMultipleTickets] = useState(false);
  const [allowMultipleAddons, setAllowMultipleAddons] = useState(true);
  const [allowBuyers, setAllowBuyers] = useState(false);
  const [selectedForm, setSelectedForm] = useState("");
  const [regIdEnabled, setRegIdEnabled] = useState(false);
  const [registrationIdSettings, setRegistrationIdSettings] = useState({
    registration_id_prefix: "",
    registration_starting_number: "01",
    registration_id_suffix: "100",
  });
  const [taxSettings, setTaxSettings] = useState({
    registrationNumber: "",
    taxes: [],
    displayOption: "include",
  });

  const handleAddTax = () => {
    setTaxSettings({
      ...taxSettings,
      taxes: [...taxSettings.taxes, { name: "", percentage: "" }],
    });
  };

  const handleRemoveTax = (index) => {
    const updatedTaxes = [...taxSettings.taxes];
    updatedTaxes.splice(index, 1);
    setTaxSettings({
      ...taxSettings,
      taxes: updatedTaxes,
    });
  };

  const handleTaxChange = (index, field, value) => {
    const updatedTaxes = [...taxSettings.taxes];
    updatedTaxes[index] = { ...updatedTaxes[index], [field]: value };
    setTaxSettings({
      ...taxSettings,
      taxes: updatedTaxes,
    });
  };

  const updateSettings = async () => {
    const hasPermission = await checkPermission("Settings", "update");
    if (!hasPermission) return;

    if (!taxSettings.registrationNumber) {
      showToast("Tax registration number cannot be empty", "error");
      return;
    }

    for (let i = 0; i < taxSettings.taxes.length; i++) {
      const tax = taxSettings.taxes[i];
      const perc = Number.parseFloat(tax.percentage);
      if (!tax.percentage || isNaN(perc) || perc < 0 || perc > 100) {
        showToast(
          `Invalid tax percentage for ${
            tax.name || `Tax ${i + 1}`
          }. It must be a number between 0 and 100.`,
          "error"
        );
        return;
      }
    }

    try {
      const payload = {
        event_id: localStorage.getItem("eventId"),
        allow_login: allowLogin ? 1 : 0,
        allow_buyers: allowBuyers ? 1 : 0,
        buyer_form: selectedForm,
        allow_attendee_buy_multiple_ticket: allowMultipleTickets ? 1 : 0,
        allow_attendee_buy_multiple_addon: allowMultipleAddons ? 1 : 0,
        support: helpSupportEnabled ? 1 : 0,
        support_email: helpEmail,
        tax_settings: {
          tax_registration_number: taxSettings.registrationNumber,
          tax_display:
            taxSettings.displayOption === "add" ? "add_to_total" : "include",
          tax_options: taxSettings.taxes.map((tax) => ({
            tax_name: tax.name,
            tax_percentage: Number(tax.percentage),
          })),
        },
      };

      const response = await axios.post(
        `${localserver}/updateSettings`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.success) {
        showToast(response.data.message, "success");
        fetchSettingsDetails();
        getValidation();
      } else {
        showToast(
          response.data.message || "Failed to update settings",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      showToast("An error occurred while updating settings", "error");
    }
  };
  const handleSaveRegistration = () => {
    const startNum = Number(
      registrationIdSettings.registration_starting_number
    );
    if (isNaN(startNum) || startNum < 0) {
      showToast("Starting number must be a positive integer", "error");
      return;
    }
    const payload = {
     event_id: localStorage.getItem("eventId"),
      registration_id_prefix: registrationIdSettings.registration_id_prefix,
      registration_starting_number: startNum.toString(),
      registration_id_suffix: registrationIdSettings.registration_id_suffix,
    };
    UpdateCustomeRegCode(payload)
    .then((res)=>{
     
       if (res.success) {
        showToast(res.message, "success");
        fetchSettingsDetails();
        getValidation();
      } else {
        showToast(
          res.message || "Failed to update settings",
          "error"
        );
      }
    })
    .catch((err)=>{
    
      showToast(
          err.response.data.error || "Failed to update settings",
          "error"
        );
    })
  };
  const renderHeader = () => (
    <div style={{ marginBottom: "22px" }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                <i className="fa fa-gear"></i>
              </div>
              Settings
            </h2>
          </div>
          <div className="col-md-6 text-end"></div>
        </div>
      </div>
    </div>
  );

  const renderNavigationTabs = () => (
    <div style={{ marginBottom: "22px" }}>
      <div
        style={{
          margin: "0 auto",
          display: "flex",
          gap: "0.5rem",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "15px 24px",
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="settings-tab-wrapper">
          <button
            className={`settings-tab ${
              activeTab === "general" ? "active" : ""
            }`}
            onClick={() => setActiveTab("general")}
          >
            <div className="tab-icon">
              <FaCheckCircle size={18} />
            </div>
            <div className="tab-text">
              <span className="tab-title">General</span>
              <span className="tab-subtitle">Post-registration settings</span>
            </div>
          </button>

          <button
            className={`settings-tab ${
              activeTab === "attendees" ? "active" : ""
            }`}
            onClick={() => setActiveTab("attendees")}
          >
            <div className="tab-icon">
              <FaUsers size={18} />
            </div>
            <div className="tab-text">
              <span className="tab-title">Attendees & Buyers</span>
              <span className="tab-subtitle">User management settings</span>
            </div>
          </button>

          <button
            className={`settings-tab ${activeTab === "tax" ? "active" : ""}`}
            onClick={() => setActiveTab("tax")}
          >
            <div className="tab-icon">
              <FaClipboardList size={18} />
            </div>
            <div className="tab-text">
              <span className="tab-title">Tax</span>
              <span className="tab-subtitle">Tax management settings</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );

  const [checkUserLoading, setCheckUserLoading] = useState(false);
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Settings", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error Check Permission:", error);
    } finally {
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);

  useEffect(() => {
    fetchSettingsDetails();
  }, []);
useEffect(() => {

  if (regDetails && Object.keys(regDetails).length > 0) {
    setRegIdEnabled(true);
    setRegistrationIdSettings({
      registration_id_prefix: regDetails.registration_id_prefix || "",
      registration_starting_number: String(regDetails.registration_starting_number || 1).padStart(2, "0"),
      registration_id_suffix: regDetails.registration_id_suffix || "",
    });
  } else {
    // Reset if no custom reg ID
    setRegIdEnabled(false);
    setRegistrationIdSettings({
      registration_id_prefix: "",
      registration_starting_number: "01",
      registration_id_suffix: "100",
    });
  }
}, [regDetails]);




  useEffect(() => {
    if (!settingsDetails) return;

    setHelpSupportEnabled(settingsDetails?.support === 1);
    setHelpEmail(settingsDetails?.support_email || "");
    setAllowLogin(settingsDetails?.allow_login === 1);
    setAllowMultipleTickets(
      settingsDetails?.allow_attendee_buy_multiple_ticket === 1
    );
    setAllowMultipleAddons(
      settingsDetails?.allow_attendee_buy_multiple_addon === 1
    );
   

    setAllowBuyers(settingsDetails?.allow_buyers === 1);
    setSelectedForm(settingsDetails?.buyer_form?.toString() || "");

    try {
      const taxSettingsData = JSON.parse(settingsDetails?.tax_settings || "{}");
      setTaxSettings({
        registrationNumber: taxSettingsData.tax_registration_number || "",
        displayOption:
          taxSettingsData.tax_display === "add_to_total" ? "add" : "include",
        taxes: taxSettingsData.tax_options?.map((tax) => ({
          name: tax.tax_name,
          percentage: tax.tax_percentage.toString(),
        })) || [
          { name: "SGST", percentage: "9" },
          { name: "CGST", percentage: "9" },
          { name: "IGST", percentage: "18" },
        ],
      });
    } catch (error) {
      console.error("Error parsing tax_settings:", error);
      showToast("Failed to load tax settings", "error");
    }

  
  }, [settingsDetails]);

  const previewRegId = () => {
    const {
      registration_id_prefix,
      registration_starting_number,
      registration_id_suffix,
    } = registrationIdSettings;
    const start = registration_starting_number.padStart(2, "0");
    return `${registration_id_prefix}-${start}-${registration_id_suffix}`;
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        padding: "24px 15px",
      }}
    >
      <ToastMessage />
      {renderHeader()}
      {renderNavigationTabs()}

      <div style={{ margin: "0 auto" }}>
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            overflow: "hidden",
          }}
        >
          {activeTab === "general" && (
            <div style={{ padding: "15px 24px" }}>
              <div
                style={{
                  marginBottom: "22px",
                  paddingBottom: "15px",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <h2
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1f2937",
                    margin: "0 0 0.5rem 0",
                  }}
                >
                  General Settings
                </h2>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#6b7280",
                    margin: 0,
                    lineHeight: "1.5",
                  }}
                >
                  Configure what happens after users complete their registration
                </p>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "0px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "0px",
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaCheckCircle />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Registration Complete Page
                  </h3>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: helpSupportEnabled
                        ? "#184778"
                        : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => setHelpSupportEnabled(!helpSupportEnabled)}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: helpSupportEnabled
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Help & Support
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      If enabled, help and feedback messages will be sent to the
                      email address provided here.
                    </p>

                    {helpSupportEnabled && (
                      <div style={{ marginTop: "16px" }}>
                        <label
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: "500",
                            color: "#374151",
                            margin: "0 0 8px 0",
                            display: "block",
                          }}
                        >
                          Email for help and feedback messages
                        </label>
                        <input
                          type="email"
                          placeholder="Add an address email"
                          value={helpEmail}
                          onChange={(e) => setHelpEmail(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "12px 16px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            backgroundColor: "#ffffff",
                            transition:
                              "border-color 0.2s ease, box-shadow 0.2s ease",
                            outline: "none",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <button
                  style={{
                    backgroundColor: "#184778",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition:
                      "background-color 0.2s ease, transform 0.1s ease",
                    alignSelf: "flex-start",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0f3a5f";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#184778";
                    e.target.style.transform = "translateY(0)";
                  }}
                  onClick={updateSettings}
                >
                  Save Settings
                </button>
              </div>
            </div>
          )}

          {activeTab === "attendees" && (
            <div style={{ padding: "15px 24px" }}>
              <div
                style={{
                  marginBottom: "22px",
                  paddingBottom: "15px",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <h2
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1f2937",
                    margin: "0 0 0.5rem 0",
                  }}
                >
                  Attendees & Buyers Settings
                </h2>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#6b7280",
                    margin: 0,
                    lineHeight: "1.5",
                  }}
                >
                  Configure user management and registration options
                </p>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "0px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "0px",
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaLock />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Login
                  </h3>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: allowLogin ? "#184778" : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => setAllowLogin(!allowLogin)}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: allowLogin
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Allow login of attendees & buyers
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      If enabled, attendees and buyers can login in to the
                      dashboard to view, purchased, cancel or modify their
                      tickets.
                    </p>
                  </div>
                </div>

                <button
                  style={{
                    backgroundColor: "#184778",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition:
                      "background-color 0.2s ease, transform 0.1s ease",
                    alignSelf: "flex-start",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0f3a5f";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#184778";
                    e.target.style.transform = "translateY(0)";
                  }}
                  onClick={updateSettings}
                >
                  Save Login Settings
                </button>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "0px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "0px",
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaUsers />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Attendees
                  </h3>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: allowMultipleTickets
                        ? "#184778"
                        : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() =>
                      setAllowMultipleTickets(!allowMultipleTickets)
                    }
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: allowMultipleTickets
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Allow selection of multiple ticket types
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      If enabled attendees can purchase various type of tickets
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: allowMultipleAddons
                        ? "#184778"
                        : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => setAllowMultipleAddons(!allowMultipleAddons)}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: allowMultipleAddons
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Allow selection of multiple add-on types
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      If enabled attendees can purchase various type of add-ons
                    </p>
                  </div>
                </div>

                <button
                  style={{
                    backgroundColor: "#184778",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition:
                      "background-color 0.2s ease, transform 0.1s ease",
                    alignSelf: "flex-start",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0f3a5f";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#184778";
                    e.target.style.transform = "translateY(0)";
                  }}
                  onClick={updateSettings}
                >
                  Save Attendee Settings
                </button>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "0px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "0px",
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaClipboardList />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Registration ID
                  </h3>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: regIdEnabled ? "#184778" : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => setRegIdEnabled(!regIdEnabled)}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: regIdEnabled
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Customize registration ID
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      If enabled, customize your Registration ID format to fit
                      your event needs.
                    </p>

                    {regIdEnabled && (
                      <>
                        <div
                          style={{
                            backgroundColor: "#e0f2fe",
                            border: "1px solid #0ea5e9",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            marginBottom: "16px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "0.875rem",
                            fontWeight: "500",
                            color: "#0369a1",
                          }}
                        >
                          <span>Registration ID Preview:</span>
                          <strong>{previewRegId()}</strong>
                        </div>

                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label">
                              Prefix (optional)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="e.g. EVT"
                              value={
                                registrationIdSettings.registration_id_prefix
                              }
                              onChange={(e) =>
                                setRegistrationIdSettings({
                                  ...registrationIdSettings,
                                  registration_id_prefix: e.target.value,
                                })
                              }
                            />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Starting Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="01"
                              value={
                                registrationIdSettings.registration_starting_number
                              }
                              onChange={(e) => {
                                const val = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                setRegistrationIdSettings({
                                  ...registrationIdSettings,
                                  registration_starting_number: val,
                                });
                              }}
                            />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Suffix (optional)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="100"
                              value={
                                registrationIdSettings.registration_id_suffix
                              }
                              onChange={(e) =>
                                setRegistrationIdSettings({
                                  ...registrationIdSettings,
                                  registration_id_suffix: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <button
                  style={{
                    backgroundColor: "#184778",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition:
                      "background-color 0.2s ease, transform 0.1s ease",
                    alignSelf: "flex-start",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0f3a5f";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#184778";
                    e.target.style.transform = "translateY(0)";
                  }}
                  onClick={handleSaveRegistration}
                >
                  Save Registration ID
                </button>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "0px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "0px",
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaShoppingCart />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Buyers
                  </h3>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    marginBottom: "22px",
                    padding: "20px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "48px",
                      height: "24px",
                      backgroundColor: allowBuyers ? "#184778" : "#e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => setAllowBuyers(!allowBuyers)}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        transition: "transform 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        transform: allowBuyers
                          ? "translateX(24px)"
                          : "translateX(0)",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Allow Buyers
                    </h4>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        margin: "0 0 16px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      A buyer is someone who purchases or registers for one or
                      more tickets on behalf of others. Enabling buyers allows
                      group bookings.
                    </p>

                    {allowBuyers && (
                      <div style={{ marginTop: "16px" }}>
                        <label
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: "500",
                            color: "#374151",
                            margin: "0 0 8px 0",
                            display: "block",
                          }}
                        >
                          Select a form to collect buyer details
                        </label>
                        <select
                          value={selectedForm}
                          onChange={(e) => setSelectedForm(e.target.value)}
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            padding: "12px 16px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            backgroundColor: "#ffffff",
                            cursor: "pointer",
                            appearance: "none",
                            backgroundImage:
                              'url(\'data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23666" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>\')',
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right 12px center",
                            backgroundSize: "12px",
                          }}
                        >
                          <option value="">Choose a Form</option>
                          {buyerForm
                            .filter((e) => e.form_type === "Buyer")
                            .map((form) => (
                              <option key={form.id} value={form.id}>
                                {form.form_title}
                              </option>
                            ))}
                        </select>

                        <div
                          style={{
                            backgroundColor: "#f0f9ff",
                            border: "1px solid #0ea5e9",
                            borderRadius: "8px",
                            padding: "12px 16px",
                            marginTop: "16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              backgroundColor: "#0ea5e9",
                              color: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "12px",
                              fontWeight: "bold",
                              flexShrink: 0,
                            }}
                          >
                            i
                          </div>
                          <p
                            style={{
                              fontSize: "0.875rem",
                              color: "#0369a1",
                              margin: 0,
                            }}
                          >
                            If no form is selected, only <strong>name</strong>{" "}
                            and <strong>email address</strong> will be collected
                            by default
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <button
                  style={{
                    backgroundColor: "#184778",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition:
                      "background-color 0.2s ease, transform 0.1s ease",
                    alignSelf: "flex-start",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0f3a5f";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#184778";
                    e.target.style.transform = "translateY(0)";
                  }}
                  onClick={updateSettings}
                >
                  Save Buyer Settings
                </button>
              </div>
            </div>
          )}

          {activeTab === "tax" && (
            <div style={{ padding: "15px 24px" }}>
              <div
                style={{
                  marginBottom: "22px",
                  paddingBottom: "15px",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <h2
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1f2937",
                    margin: "0 0 0.5rem 0",
                  }}
                >
                  Tax Settings
                </h2>
                <p
                  style={{
                    fontSize: "16px",
                    color: "#6b7280",
                    margin: 0,
                    lineHeight: "1.5",
                  }}
                >
                  Configure tax management for your event
                </p>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #f3f4f6",
                  borderRadius: "12px",
                  padding: "24px",
                  marginBottom: "22px",
                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "22px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f3f4f6",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      backgroundColor: "#184778",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      color: "#ffffff",
                    }}
                  >
                    <FaUsers />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    Tax Management
                  </h3>
                </div>

                <div className="body">
                  <div className="">
                    <p className="text-muted mb-4">
                      Add the tax methods that will be applied to the tickets &
                      add-ons
                    </p>
                    <Alert
                      variant="info"
                      style={{
                        background: "#e3f2fd",
                        border: "1px solid #bbdefb",
                        borderRadius: "8px",
                        padding: "12px 15px",
                        marginBottom: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <FaInfoCircle />
                        <span>
                          If the Event state and the Organization state are the
                          same, SGST + CGST will be calculated; otherwise, if
                          the states differ, IGST will be applied.
                        </span>
                      </div>
                    </Alert>
                    <div className="form-group mb-4">
                      <label style={{ textTransform:"none"}}>
                        Tax Registration Number (e.g., 22AAAAA0000A1Z56){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={taxSettings.registrationNumber}
                        onChange={(e) =>
                          setTaxSettings({
                            ...taxSettings,
                            registrationNumber: e.target.value,
                          })
                        }
                      />
                    </div>

                    {taxSettings.taxes.map((tax, index) => (
                      <div
                        key={index}
                        className="tax-row mb-4 add_attendites_model"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label">Tax Name </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e.g. VAT, GST"
                                disabled={
                                  tax.percentage ||
                                  ["SGST", "CGST", "IGST"].includes(tax.name)
                                }
                                value={tax.name}
                                onChange={(e) =>
                                  handleTaxChange(index, "name", e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label className="form-label">
                                Tax Percentage{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="tex_price_flex">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter tax percentage"
                                  value={tax.percentage}
                                  onChange={(e) =>
                                    handleTaxChange(
                                      index,
                                      "percentage",
                                      e.target.value
                                    )
                                  }
                                />
                                <span className="input-group-text">%</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 d-flex align-items-center">
                            {index > 2 && (
                              <div>
                                <label className="form-label"></label>
                                <button
                                  className="search_toggle btn btn-danger"
                                  onClick={() => handleRemoveTax(index)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                    <button
                      className="btn btn-primary mb-2"
                      onClick={handleAddTax}
                    >
                      <FaPlus className="me-2" /> Add New Tax
                    </button>

                    <div className="form-group">
                      <label style={{ marginBottom: "3rem" }}>
                        How would you like to display the tax?{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div>
                        <FormCheck
                          type="radio"
                          id="add-tax"
                          name="taxDisplay"
                          label="Add tax to the total amount at checkout"
                          checked={taxSettings.displayOption === "add"}
                          onChange={() =>
                            setTaxSettings({
                              ...taxSettings,
                              displayOption: "add",
                            })
                          }
                        />
                        <FormCheck
                          type="radio"
                          id="include-tax"
                          name="taxDisplay"
                          label="Include tax in the ticket price"
                          checked={taxSettings.displayOption === "include"}
                          onChange={() =>
                            setTaxSettings({
                              ...taxSettings,
                              displayOption: "include",
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    style={{
                      backgroundColor: "#184778",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition:
                        "background-color 0.2s ease, transform 0.1s ease",
                      alignSelf: "flex-start",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#0f3a5f";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#184778";
                      e.target.style.transform = "translateY(0)";
                    }}
                    onClick={updateSettings}
                  >
                    Save Tax Settings
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
